import { useParams, useSearchParams } from "react-router";
import { useCookie } from "react-use";
import { Page } from "../../analytics/Page.tsx";
import { useConfig } from "../../hooks/index.ts";
import { NoTenantMessage, NoUserIdMessage } from "./components/index.ts";
import { useAfterLoginRedirectUrl, useSetApp } from "./hooks/index.ts";
import { Login } from "./Login.tsx";

export const LoginPage = () => {
  const config = useConfig();
  const [externalIdCookie] = useCookie("pick3_external_id");
  const routeParams = useParams<{ tenant?: string }>();
  const [searchParams] = useSearchParams();

  const app = routeParams.tenant ?? searchParams.get("tenant") ?? config.tenant;
  const provider = searchParams.get("provider") ?? "UNKNOWN";
  const externalId = searchParams.get("userId") ?? externalIdCookie;
  const redirectTo = useAfterLoginRedirectUrl();

  useSetApp(app);

  if (!app) {
    return <NoTenantMessage />;
  }

  if (!externalId) {
    return <NoUserIdMessage />;
  }

  return (
    <Page name="Login">
      <Login
        redirectTo={redirectTo}
        externalId={externalId}
        provider={provider}
      />
    </Page>
  );
};
